/*eslint-disable*/
import moment from "moment";
import values from "lodash/values";
import PropTypes from "prop-types";
import React, { Component, forwardRef } from "react";
import Articles from "articles";

import ActionBarContainer from "./ActionBarContainer";
import MessageForm from "./MessageForm";
import TestimonialForm from "./TestimonialForm";
import ToolbarDefault from "./ToolbarDefault";
import ToolbarRate from "./ToolbarRate";
import RerouteButtonFooter from "./messages/RerouteButtonFooter";
import OptOutForFutureReference from "./messages/OptOutForFutureReference";
import { RerouteContext } from "./RerouteContext";
import Analytics from "../../utils/chat/Analytics";
import ChatActions from "../../actions/ChatActions";
import { EVENT_ACTIONS } from "../../constants/AnalyticsConstants";
import { history } from "../../utils/chat/chatNavigation";
import MessageType from "../../constants/ChatMessageTypes";
import RatingSystemType from "../../constants/ChatRatingSystemTypes";
import i18next from "../../utils/i18next";

const THRESHOLD_DURATION_IN_MILLIS = 12 * 60 * 60 * 1000;

export class Footer extends Component {
    constructor({ props }) {
        super(props);

        this.state = {
            disableAcceptButton: false,
            showRerouteFooter: true,
            rerouteCompleted: false,
            rerouteType: null,
        };

        this.handleRerouteComplete = this.handleRerouteComplete.bind(this);
        this.handleReroute = this.handleReroute.bind(this);
        this.onAcceptResponse = this.onAcceptResponse.bind(this);
        this.onAcceptResponseSubmit = this.onAcceptResponseSubmit.bind(this);
        this.onMessageTextChange = this.onMessageTextChange.bind(this);
        this.onMinimize = this.onMinimize.bind(this);
    }

    // handleRerouteComplete() {
    //     this.setState({ showRerouteFooter: false });
    // }

    handleRerouteComplete(type) {
        this.setState({ showRerouteFooter: false, rerouteCompleted: true });
        this.context.setRerouteType(type);
    }

    handleReroute() {
        this.setState({ rerouteCompleted: true });
    }

    onAcceptResponse() {
        const { confirmAccepts } = this.props.question;

        if (confirmAccepts) {
            const acceptResponseButton = {
                label: i18n.t("rtm.button.accept_and_close"),
                onClick: this.onAcceptResponseSubmit,
            };
            const closeActionBarButton = {
                label: i18n.t("rtm.button.not_yet"),
                onClick: ChatActions.clearActionBar.defer,
            };

            ChatActions.createActionBar({
                buttons: [acceptResponseButton, closeActionBarButton],
                messageType: MessageType.AcceptResponseConfirmationMessage,
            });
        } else {
            this.onAcceptResponseSubmit();
        }
    }

    onAcceptResponseSubmit() {
        const { question, response } = this.props;

        ChatActions.responseAccept({
            questionUuid: question.uuid,
            prevHappiness: response.happiness,
            responseId: response.id,
        });
    }

    onMessageTextChange(messageText) {
        this.setState({
            disableAcceptButton: Boolean(messageText.trim()),
        });
    }

    onMinimize() {
        Analytics.sendGaEvent({ action: EVENT_ACTIONS.CulDeSacSessionClosed });
        history.push("minimized");
    }

    render() {
        const {
            autoResponse,
            companyName,
            enableRatingAutoResponse,
            hasRejectedAutoResponse,
            hasAcceptedAutoResponse,
            hasTerminalAutoResponse,
            isAnsweredByExperts,
            isLoadingExperts,
            lastResponseTimeInMillis,
            onSetOffsetBottomOfMessageList,
            question,
            questionIsRerouted,
            ratingSystem,
            response,
            scrollMessageListToBottom,
            shouldDisplayConfirmationMessage,
        } = this.props;
        const { disableAcceptButton } = this.state;
        const hasAutoResponse = Boolean(autoResponse);
        const questionIsClosed = Boolean(question.dateClosed);
        const questionIsReroutedAndUnresolved = questionIsRerouted && question.status === 0;
        const showFeedbackForms =
            isAnsweredByExperts || hasRejectedAutoResponse || hasAcceptedAutoResponse || hasTerminalAutoResponse;
        const showRatingsToolbar =
            (!rerouteCompleted && (hasTerminalAutoResponse || hasAcceptedAutoResponse) && enableRatingAutoResponse) ||
            (isAnsweredByExperts &&
                (!questionIsReroutedAndUnresolved ||
                    question.hasOfficialMessages ||
                    question.closeQuestionWhenEscalated));
        const showMessageForm = isAnsweredByExperts || hasRejectedAutoResponse;
        const { showRerouteFooter } = this.state;
        const { rerouteCompleted } = this.state;

        const showFooter =
            ["Alexkumar", "Autodesk", "Madonna 1234", "rainbow", "Redwood", "Autodesk Sandbox", "AllenMuse"].includes(
                question.company
            ) &&
            showRerouteFooter &&
            !rerouteCompleted;

        return (
            <div className="thread-view-footer" ref={this.props.forwardedRef}>
                {shouldDisplayConfirmationMessage ? (
                    <ActionBarContainer
                        scrollMessageListToBottom={scrollMessageListToBottom}
                        setOffsetBottomOfMessageList={onSetOffsetBottomOfMessageList}
                    />
                ) : (
                    <div>
                        {showFeedbackForms && (
                            <div>
                                {/*
                                 * TODO: consolidate TestimonialForm and
                                 * MessageForm since they have a lot of shared
                                 * functionality
                                 */}
                                {/* {showMessageForm && 
                                    (response.isLeavingTestimonial ? (
                                        <TestimonialForm
                                            setOffsetBottomOfMessageList={onSetOffsetBottomOfMessageList}
                                        />
                                    ) : (
                                        <MessageForm
                                            onMessageTextChange={this.onMessageTextChange}
                                            question={question}
                                            response={response}
                                            scrollMessageListToBottom={scrollMessageListToBottom}
                                            setOffsetBottomOfMessageList={onSetOffsetBottomOfMessageList}
                                        />
                                    ))} */}
                                {showMessageForm &&
                                    showRerouteFooter &&
                                    !questionIsReroutedAndUnresolved &&
                                    (response.isLeavingTestimonial ? (
                                        <TestimonialForm
                                            setOffsetBottomOfMessageList={onSetOffsetBottomOfMessageList}
                                        />
                                    ) : (
                                        <MessageForm
                                            onMessageTextChange={this.onMessageTextChange}
                                            question={question}
                                            response={response}
                                            scrollMessageListToBottom={scrollMessageListToBottom}
                                            setOffsetBottomOfMessageList={onSetOffsetBottomOfMessageList}
                                        />
                                    ))}

                                {showRatingsToolbar &&
                                    showRerouteFooter &&
                                    !questionIsReroutedAndUnresolved &&
                                    (response.isLeavingRating ? (
                                        <ToolbarRate
                                            question={question}
                                            ratingSystem={ratingSystem}
                                            response={response}
                                            setOffsetBottomOfMessageList={onSetOffsetBottomOfMessageList}
                                        />
                                    ) : (
                                        <ToolbarDefault
                                            disableAcceptButton={disableAcceptButton}
                                            hasAutoResponse={hasAutoResponse}
                                            onAcceptAnswer={this.onAcceptResponse}
                                            question={question}
                                            ratingSystem={ratingSystem}
                                            response={response}
                                            setOffsetBottomOfMessageList={onSetOffsetBottomOfMessageList}
                                            showAcceptAnswerControl={!hasTerminalAutoResponse}
                                        />
                                    ))}

                                {showFooter && !questionIsReroutedAndUnresolved && !questionIsClosed && (
                                    <div>
                                        <p className="para-head-message">
                                            To Opt Out of receiving answers from the Autodesk experts please click the
                                            below buttons
                                        </p>
                                        <div className="FooterSection">
                                            <RerouteButtonFooter
                                                question={question}
                                                // onRerouteComplete={this.handleRerouteComplete}
                                                onRerouteComplete={() => this.handleRerouteComplete("reroute")}
                                            />

                                            <OptOutForFutureReference
                                                question={question}
                                                //  onRerouteComplete={this.handleRerouteComplete}
                                                onRerouteComplete={() => this.handleRerouteComplete("optout")}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}

                        {!isAnsweredByExperts && !questionIsRerouted && !hasAutoResponse && (
                            <div>
                                {showFooter && (
                                    <div>
                                        <p className="para-head-message">
                                            To Opt Out of receiving answers from the Autodesk experts please click the
                                            below buttons
                                        </p>

                                        <div className="FooterSection">
                                            <RerouteButtonFooter
                                                question={question}
                                                onRerouteComplete={() => this.handleRerouteComplete("reroute")}
                                            />

                                            <OptOutForFutureReference
                                                question={question}
                                                //  onRerouteComplete={this.handleRerouteComplete}
                                                onRerouteComplete={() => this.handleRerouteComplete("optout")}
                                            />
                                        </div>
                                    </div>
                                )}
                                {!isLoadingExperts && (
                                    <div>
                                        {lastResponseTimeInMillis < THRESHOLD_DURATION_IN_MILLIS ? (
                                            <p
                                                className="expert-response-time"
                                                // eslint-disable-next-line react/no-danger
                                                dangerouslySetInnerHTML={{
                                                    __html: i18n.t("rtm.text.response_time", {
                                                        companyName:
                                                            i18next.language === "en"
                                                                ? Articles.articlize(companyName)
                                                                : companyName,
                                                        lastResponseTime: moment
                                                            .duration(lastResponseTimeInMillis)
                                                            .humanize(),
                                                    }),
                                                }}
                                            />
                                        ) : (
                                            <p className="expert-response-time">
                                                {i18n.t("rtm.text.response_time_help")}
                                            </p>
                                        )}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

Footer.defaultProps = {
    autoResponse: {},
    forwardedRef: null,
    lastResponseTimeInMillis: null,
};

Footer.contextType = RerouteContext;

Footer.propTypes = {
    autoResponse: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
    companyName: PropTypes.string.isRequired,
    enableRatingAutoResponse: PropTypes.bool.isRequired,
    forwardedRef: PropTypes.shape({
        current: PropTypes.instanceOf(Element),
    }),
    hasRejectedAutoResponse: PropTypes.bool.isRequired,
    hasAcceptedAutoResponse: PropTypes.bool.isRequired,
    hasTerminalAutoResponse: PropTypes.bool.isRequired,
    isAnsweredByExperts: PropTypes.bool.isRequired,
    isLoadingExperts: PropTypes.bool.isRequired,
    lastResponseTimeInMillis: PropTypes.number,
    onSetOffsetBottomOfMessageList: PropTypes.func.isRequired,
    question: PropTypes.shape({
        confirmAccepts: PropTypes.bool.isRequired,
    }).isRequired,
    questionIsRerouted: PropTypes.bool.isRequired,
    ratingSystem: PropTypes.oneOf(values(RatingSystemType)).isRequired,
    response: PropTypes.shape({}).isRequired,
    scrollMessageListToBottom: PropTypes.func.isRequired,
    shouldDisplayConfirmationMessage: PropTypes.bool.isRequired,
};

export default forwardRef((props, ref) => <Footer {...props} forwardedRef={ref} />);
